import './base.css';
import './styles/custom-animations.css';

import { enableES5, enableMapSet } from 'immer';
import ReactDOM from 'react-dom';
import 'tailwindcss/tailwind.css';
import App from './App';

enableES5();
enableMapSet();
ReactDOM.render(<App />, document.getElementById('app'));
